module.exports = __webpack_public_path__ + "static/media/sorted_array.4ebadc5f.png";